// 소프트 그린 아바타 팔레트 — 쿨 톤 위주, 레드 계열 제외(에러 전용)
export const AVATAR_PALETTE = [
  '#46a758', // green
  '#02b889', // mint
  '#8b6cf0', // violet
  '#fb9b34', // orange
  '#18b7d8', // cyan
  '#8b95a1', // slate
] as const;

export function avatarColorFor(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  }
  return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length];
}
